import Vue from "vue";
import VueCompositionAPI from "@vue/composition-api";
import { VueQueryPlugin } from "@tanstack/vue-query";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { queryClient } from "./config/queryClient";
import "./assets/tailwind.css";
import VueSweetalert2 from "vue-sweetalert2";

// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";

Vue.config.productionTip = false;

/* WAJIB: composition-api dipasang SEBELUM VueQueryPlugin & sebelum new Vue() */
Vue.use(VueCompositionAPI);
Vue.use(VueQueryPlugin, { queryClient });
Vue.use(VueSweetalert2);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
